import { useEffect, useState } from "react";
import styles from "./PostPoll.module.css";
import { useDispatch, useSelector } from "react-redux";
import { pollVote } from "../../../redux/actions/postActions";

export default function PostPoll({ poll, id }) {
  const { data } = useSelector((state) => state.currentProfile);
  const [hasVoted, setHasVoted] = useState();
  const [userVotedOptionIndex, setUserVotedOptionIndex] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    setUserVotedOptionIndex(
      poll.options.findIndex((opt) => opt.votes.some((v) => v._id === data._id))
    );
  }, [poll, data]);

  useEffect(() => {
    setHasVoted(userVotedOptionIndex !== -1);
  }, [userVotedOptionIndex]);

  const totalVotes = poll.options.reduce(
    (sum, opt) => sum + opt.votes.length,
    0
  );

  const handleVote = async (index, e) => {
    if (hasVoted) return;
    dispatch(pollVote({ id, data: { index } }));
  };

  return (
    <div className={styles.pollContainer}>
      {poll.options.map((opt, i) => {
        const voteCount = opt.votes.length;
        const percentage =
          totalVotes > 0 ? ((voteCount / totalVotes) * 100).toFixed(1) : 0;
        const isSelected = i === userVotedOptionIndex;

        return (
          <div key={i} className={styles.optionRow}>
            {hasVoted ? (
              <div
                className={`${styles.optionResult} ${
                  isSelected ? styles.selected : ""
                }`}
              >
                <div className={styles.optionInfo}>
                  <span className={`${styles.optionText} header-font`}>{opt.text}</span>
                  <span className={styles.percentage}>
                    {percentage}% ({voteCount})
                  </span>
                </div>
                <div className={styles.resultBar}>
                  <div
                    className={styles.fill}
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </div>
            ) : (
              <button
                type="button"
                className={`${styles.optionButton} header-font ${
                  isSelected ? styles.selected : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleVote(i);
                }}
              >
                {opt.text}
              </button>
            )}
          </div>
        );
      })}
      {hasVoted && (
        <p className={styles.totalVotes}>
          {totalVotes} vote{totalVotes !== 1 ? "s" : ""}
        </p>
      )}
    </div>
  );
}
